export namespace PolicyAction {

    export class GetListByOfferId {
        static readonly type = 'PolicyAction.GetListByOfferId';

        constructor(public id: number) {
        }
    }

    export class Printout {
        static readonly type = 'PolicyAction.Printout';

        constructor(public id: number, public all: boolean) {
        }
    }

    export class PrintoutSummary {
        static readonly type = 'PolicyAction.PrintoutSummary';

        constructor(public id: number) {
        }
    }

    export class PrintoutFrontierCertificate {
        static readonly type = 'PolicyAction.PrintoutFrontierCertificate';

        constructor(public id: number) {
        }
    }

}
